import React, { useEffect, useState } from "react";
import Loader from "../global/Loader";
import DataTable from "../datatable/DataTable";
import { payments } from "../../constants/data";
import CurrencyFormatter from "../global/CurrencyFormatter";
import DateTimeFormat from "../global/DateTimeFormat";
import { connect } from "react-redux";
import HeaderInfo from "../agents/HeaderInfo";
import Button from "../global/Button";

function BankTransfersReport(props) {
  const headers = [
    "Transaction ID",
    "Amount",
    "Transaction date",
    "Account number",
    "Commission",
    "Print statement",
  ];
  let tableRows = [];

  let commission = 0;

  let list = payments?.filter(
    (item) =>
      Number(item.status) === 1 && item.bank_id === props.selectedBank?.bank_id
  );

  if (list.length) {
    for (let i = 0; i < list.length; i++) {
      let commissionEarned = list[i].amount * props.selectedBank?.commission;
      commission = commission += commissionEarned;
      tableRows.push({
        payment_id: list[i].payment_id,
        amount: <CurrencyFormatter value={list[i].amount} />,
        created_at: <DateTimeFormat>{list[i].created_at}</DateTimeFormat>,
        account_number: list[i].account_number,
        commission: <CurrencyFormatter value={commissionEarned} />,
        more: (
          <i
            className="bx bx-printer links text-[16px] cursor-pointer"
            onClick={() => printStatement(list[i])}
          ></i>
        ),
      });
    }
  }

  const printStatement = (id) => {
    console.log(id);
  };
  // fetching data
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());

  useEffect(() => {
    handleAction(selectedMonth);
  }, [selectedMonth]);

  let handleAction = (val) => {
    console.log(val);
  };

  const displayContent = list ? (
    <DataTable headers={headers} data={tableRows} />
  ) : (
    <Loader />
  );

  return (
    <div>
      {/* header information */}
      <HeaderInfo commission={commission} action={setSelectedMonth} />
      <div className="flex items-center justify-end mb-3">
        <Button text={"Export Excel"} />
        <Button text={"Export PDF"} bgColor={"bg-red-500"} />
      </div>
      {displayContent}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    selectedBank: state.banks?.selectedBank ?? {},
  };
};

export default connect(mapStateToProps)(BankTransfersReport);
